import React, { useState, useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function FooterContentSection() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 768 && window.innerWidth < 992);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
      setIsTablet(window.innerWidth >= 768 && window.innerWidth < 992);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const cards = [
    {
      title: "Buying Used as Easy as Buying New",
      description: "One clean product page per GPU model, clear condition lanes, and a simple Buy Now or bid flow. No custom listings, no haggling, no sketchy DMs—just pick the card, choose your price, and check out."
    },
    {
      title: "GPUwiz Verified Testing",
      description: "Every Used (Tested) GPU is function-tested by GPUwiz before it's allowed to ship: benchmarks, thermals, artifact checks, ports, and fan operation. Buyers get working cards, sellers get fewer disputes."
    },
    {
      title: "Fair Price by Design",
      description: "GPUwiz runs on a bid/ask order book like a stock market. Buy Now always hits the lowest available ask for that model, and you can place bids below that if you want to wait for a better deal."
    },
    {
      title: "One Set of Rules for Every Listing",
      description: "No seller-by-seller fine print. Every GPU on GPUwiz follows the same lanes, QA checks, and return rules, so you always know what \"New (Resale)\" or \"Used (Tested)\" actually means before you buy or sell."
    }
  ];

  return (
    <Container 
      fluid
      style={{
        paddingTop: isMobile ? '30px' : isTablet ? '40px' : '50px',
        paddingBottom: isMobile ? '30px' : isTablet ? '40px' : '50px',
        backgroundColor: '#FFFFFF'
      }}
    >
      <Row style={{ margin: 0, alignItems: 'flex-start' }}>
        {cards.map((card, index) => (
          <Col
            key={index}
            xs={12}
            sm={6}
            lg={3}
            style={{
              padding: isMobile ? '6px' : '8px',
              marginBottom: isMobile && index < cards.length - 1 ? '12px' : '0'
            }}
          >
            <div
              style={{
                backgroundColor: '#2c2c2c',
                borderRadius: '8px',
                padding: isMobile ? '20px 16px' : isTablet ? '24px 20px' : '28px 24px',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                height: 'auto',
                minHeight: 'auto',
                backgroundImage: `url("/userbuysellbgimg.webp")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'center',
                boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)'

              }}
            >
              <h3
                style={{
                  color: '#FFFFFF',
                  fontSize: isMobile ? '18px' : isTablet ? '20px' : '20px',
                  fontWeight: '700',
                  margin: 0,
                  marginBottom: isMobile ? '12px' : '16px',
                  lineHeight: '1.3',
                  textAlign: 'left',
                  width: '100%',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  display: '-webkit-box',
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  height: isMobile ? '' : '52px',
                  minHeight: isMobile ? '' : '52px'
                }}
              >
                {card.title}
              </h3>
              <p
                style={{
                  color: '#FFFFFF',
                  fontSize: isMobile ? '12px' : isTablet ? '11px' : '12px',
                  fontWeight: '400',
                  margin: 0,
                  lineHeight: '1.6',
                  textAlign: 'left',
                  width: '100%',
                  wordWrap: 'break-word',
                  overflowWrap: 'break-word',
                  whiteSpace: 'normal'
                }}
              >
                {card.description}
              </p>
            </div>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default FooterContentSection;

